import API from "../../api";
import * as actionTypes from "./actionTypes";

const showLoader = () => ({ type: actionTypes.SHOW_TEST_DRIVE_LOADER });
const hideLoader = () => ({ type: actionTypes.HIDE_TEST_DRIVE_LOADER });

export const send = (info) => (dispatch) => {
  dispatch(showLoader());

  API.testDrives.send(
    info,
    (response) => {
      dispatch(hideLoader());
      setTimeout(() => (window.location.href = "/"), 4000);
      dispatch(testDriveSent(response));
    },
    (error) => {
      dispatch(hideLoader());
      setTimeout(() => (window.location.href = "/"), 4000);
      dispatch(testDriveSendFailed(error));
    }
  );
};

const testDriveSent = (response) => ({
  type: actionTypes.TEST_DRIVE_SENT,
  response,
});
const testDriveSendFailed = (error) => ({
  type: actionTypes.TEST_DRIVE_SEND_FAILED,
  error,
});



// WEBPACK FOOTER //
// ./src/store/testDrives/actions.js